import Cookies from "js-cookie";
import { AUTHENTICATION_TOKEN_KEY, API_KEY } from "../config/constants";
import { ClientInput } from "../shared/interfaces";

export default function useToken(clientInput: ClientInput) {
    const AuthToken = Cookies.get(AUTHENTICATION_TOKEN_KEY) || clientInput.authorization;
    const APIKey = Cookies.get(API_KEY) || clientInput.apikey;
    return { AuthToken, APIKey };
}